<cap-list-loader (currentPageEventItem)="removeAllCheckboxes()" [listLoader]="listLoader"
                 [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
      <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
      <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      @if (_listLoader?.items?.length > 1) {
        <input (click)="selectAllCheckboxes(_listLoader.items, $event.target)" id="selectAllCheckbox" name="cb"
               type="checkbox"/>
      }
    </th>
    <th>
      <cap-column-header [columnName]="'Grundstueck'"
                         [sortModel]="tableSortModel.columns.get('nummer')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Art'" [sortModel]="tableSortModel.columns.get('art')"></cap-column-header>
    </th>
    <th>
      {{ "Kurzbeschreibung" | translate }}
    </th>
    <th>
      {{ "Dokumente" | translate }}
    </th>
    @if (appformatConfigService.settingsConfig$ | async; as settingsConfig) {
      @if (settingsConfig.isMapsLinkConfigured) {
        <th>
          {{ "Plan" | translate }}
        </th>
      }
    }
    <th>
      {{ "Auszug" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item; let indexOfElement = $index) {
    <tr>
      <td>
        @if (_listLoader?.items?.length > 1) {
          <input
            (click)="addCheckedGrundstueck(item, $event.target, indexNumber)"
            [checked]="ids.includes(item.dokulinkItem.id)"
            id="{{ indexOfElement }}"
            name="cb"
            type="checkbox"/>
        }
      </td>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktGrundstueck }}
          </cap-link>
        </div>
      </td>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktArt }}
          </cap-link>
        </div>
      </td>
      <td>
        <div [capHistinfo]="item.model.histInfo">
          <cap-link
            [queryParams]="{ id: item.model.id.id }"
            [target]="navTargets.NAV_GRUNDSTUECK"
            [tooltipParams]="{ nummer: item.tooltip }">
            {{ item.kompaktKurzbeschreibung }}
          </cap-link>
        </div>
      </td>
      <td>
        @if (item.model.grundstueckArt != "UNBEKANNT" && appformatConfigService.settingsConfig$ | async; as settingsConfig) {
          @if (settingsConfig.isCmisConfigured && item.model?.id) {
            <cap-cmis
              [target]="{ itemType: 'Grundstueck', id: item.model?.id.id, tooltipParam: item.model.grundstueckNummer | grundstuecknummerExtended}"></cap-cmis>
          } @else {
            <cap-dokulink [item]="item.dokulinkItem"></cap-dokulink>
          }
        }
      </td>
      @if (appformatConfigService.settingsConfig$ | async; as settingsConfig) {
        @if (settingsConfig.isMapsLinkConfigured) {
          <td>
            <cap-maps [mapType]="'grundstueck'" [model]="item.model"
                      [tooltip]="item.model.grundstueckArt | translate"></cap-maps>
          </td>
        }
      }
      <td>
        <cap-auszug [indexNumber]="indexOfElement" [item]="item.model"></cap-auszug>
      </td>
    </tr>
  }
</ng-template>
